import { storiesOf } from '@storybook/react-native';
import { Badge } from 'pawtner-mobile-ui';
import React from 'react';
import CenterView from './CenterView';

storiesOf('Badge', module)
  .addDecorator((getStory) => <CenterView>{getStory()}</CenterView>)
  .add('Without value', () => <Badge />)
  .add('With value', () => <Badge value={5} value={5} />)
  .add('Success', () => <Badge value={5} status='success' />)
  .add('Error', () => <Badge value={5} status='error' />)
  .add('Warning', () => <Badge value={5} status='warning' />)
  .add('Primary', () => <Badge value={5} status='primary' />);
